import React, { useRef } from "react";
import { Skeleton } from "antd-mobile";
import BaseTenDay from "./BaseTenDay";
import { useElementHeightToCssVar } from "@/hooks/useElementHeightToCssVar.ts";
import { homeAtom } from "@/atoms/home";
import { useAdCpt2 } from "@/hooks/adCpt/homeVendor";

// 骨架屏样式常量
const SKELETON_STYLES = {
  forecast5day: { "--width": "100%", "--height": "378px", "--border-radius": "10px" },
};

const TenDayWeather: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const homeData = useAtomValue(homeAtom);
  const forecast5day = homeData?.data?.forecast5day ?? {};

  useElementHeightToCssVar({
    targetRef: containerRef,
    cssVarKey: "--app-height-02",
    heightTakeType: "max",
  });

  // 统一返回结构，避免条件渲染影响 Hook 调用顺序
  return (
    <>
      {/* 10/15天天气预报 */}
      {isEmptyType(forecast5day) ? <Skeleton animated style={SKELETON_STYLES.forecast5day} /> : <BaseTenDay />}
      <div data-position="position-34">{useAdCpt2("position-34")}</div>
    </>
  );
};

export default TenDayWeather;
